module.exports = __webpack_public_path__ + "static/media/long.3e843d5d.png";